import React from 'react';

const footerLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Skills', href: '#skills' },
  { label: 'Projects', href: '#projects' },
  { label: 'Contact', href: '#contact' },
];

const socials = [
  { label: 'GitHub', icon: '🐙', href: 'https://github.com/' },
  { label: 'LinkedIn', icon: '💼', href: 'https://linkedin.com/in/' },
  { label: 'WhatsApp', icon: '💬', href: 'https://wa.me/+254740027395' },
];

const Footer = () => {
  const scrollTo = (e, href) => {
    e.preventDefault();
    const id = href.replace('#', '');
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-[#0a0f1e] border-t border-white/[0.06] overflow-hidden">

      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-500/40 to-transparent" />

      <div className="max-w-6xl mx-auto px-6 py-16">

        <div className="grid md:grid-cols-3 gap-12 mb-12">

          {/* Brand */}
          <div>
            <div className="font-mono text-cyan-400 text-2xl font-bold mb-4">
              CMK<span className="text-white">.</span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed">
              BSc. IT Graduate passionate about building modern web applications,
              crafting visual designs and uncovering data insights.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-widest mb-4">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  
                   <a href={link.href}
                    onClick={(e) => scrollTo(e, link.href)}
                    className="text-slate-500 hover:text-cyan-400 text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-widest mb-4">
              Get In Touch
            </h4>
            <div className="space-y-3 mb-6">
              <div>
                
                <a  href="mailto:kagukukibe@gmail.com"
                  className="text-slate-500 hover:text-cyan-400 text-sm transition-colors"
                >
                  kagukukibe@gmail.com
                </a>
              </div>
              <div>
                
                 <a href="tel:+254740027395"
                  className="text-slate-500 hover:text-cyan-400 text-sm transition-colors"
                >
                  +254 740 027 395
                </a>
              </div>
              <div>
                <span className="text-slate-500 text-sm">Nairobi, Kenya</span>
              </div>
            </div>

            <div className="flex gap-3">
              {socials.map((social) => (
                
                <a  key={social.label}
                 href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={social.label}
                  className="w-9 h-9 rounded-lg bg-white/[0.03] border border-white/[0.06] hover:border-cyan-500/30 hover:bg-cyan-500/10 flex items-center justify-center text-base transition-all duration-300"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/[0.06] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-600 text-sm">
            &copy; {new Date().getFullYear()} Cyrus Maina Kibe. All rights reserved.
          </p>
          
        </div>

      </div>
    </footer>
  );
};

export default Footer;